import { memo } from 'react'
import type { HeroSectionModelProps } from '@/components/home/components/hero-section/hero-section.model'
import { useHeroSectionModel } from '@/components/home/components/hero-section/hero-section.model'
import { HeroSectionView } from '@/components/home/components/hero-section/hero-section.view'

export const HeroSectionViewModel = memo(function HeroSectionViewModel(
  props: HeroSectionModelProps,
) {
  const model = useHeroSectionModel(props)
  return <HeroSectionView {...model} />
})
